import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { PopoverContent } from "@similarweb/ui-components";

import { TOOLTIP_WIDTH } from "app/pages/sales-intelligence/sub-modules/signals/components/tooltips/SignalsTooltip/const";

import {
    SIGNAL_SELECTION_POPOVER_SURFACE_CLASS,
    SIGNAL_SELECTION_TOOLTIP_SURFACE_CLASS,
} from "./signalSelectionTooltipClasses";

const SIGNAL_SELECTION_TOOLTIP_Z_INDEX = 10002;

const signalSelectionTooltipSurfaceStyles = `
    z-index: ${SIGNAL_SELECTION_TOOLTIP_Z_INDEX};
    max-width: ${TOOLTIP_WIDTH}px;
    padding: 0;
    color: ${colorsPalettes.carbon[0]};
    background-color: ${colorsPalettes.carbon[500]};
    border-radius: 4px;

    *:focus {
        outline: none;
    }
`;

export const StyledSignalSelectionTooltipSurface = styled.div.attrs({
    className: SIGNAL_SELECTION_TOOLTIP_SURFACE_CLASS,
})`
    ${signalSelectionTooltipSurfaceStyles}
`;

export const StyledSignalSelectionPopoverContent = styled(PopoverContent).attrs({
    className: SIGNAL_SELECTION_POPOVER_SURFACE_CLASS,
})`
    ${signalSelectionTooltipSurfaceStyles}
`;
